import BaseMemorizer from "../BaseMemorizer";

export default class DocumentGeneratorMemorizer extends BaseMemorizer{
    constructor() {
        super("updateDocumentGeneratorCmd.php");
    }
}